<template>
  <div
    :data-field="field"
    :data-weight="weight"
    class="break-inside-avoid-column mb-20"
  >
    <h4 v-if="title" class="is-5 mb-5">{{ title }}</h4>
    <div v-if="text" v-html="text" />
    <slot />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title?: string
  field?: string
  text?: string
  weight?: number
}>()
</script>
